import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const TestIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.69399 1.33203V2.98951C9.69399 4.15481 9.69399 4.73746 9.83666 5.2968C9.97932 5.85614 10.2589 6.36972 10.8181 7.3969L11.5759 8.78883C13.0009 11.4064 13.7134 12.7152 13.1289 13.6854L13.1198 13.7002C12.5267 14.6654 11.0179 14.6654 8.00032 14.6654C4.9827 14.6654 3.4739 14.6654 2.88086 13.7002L2.87182 13.6854C2.28729 12.7152 2.99978 11.4064 4.42476 8.78883L5.18252 7.3969C5.74172 6.36972 6.02132 5.85614 6.16398 5.2968C6.30664 4.73746 6.30664 4.15481 6.30664 2.98951V1.33203"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M6 10.6696L6.00579 10.668"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.0016L10.0058 12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 1.33203H10.6663"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 7.70285C5.66667 6.93392 6.73293 7.48819 8 8.21079C9.66667 9.16125 10.6667 8.43199 11 7.74212"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
